import React from 'react';
import { Chart } from 'react-google-charts';
import { Card, CardBody, CardHeader, Col, Row } from '../Bootstrap';
import './PercentageArcs.scss';
import { NoDataAvailable } from '../NoDataAvailable';
const classNames = require('classnames');

const arc = 2 / 3;

export class PercentageArcs extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.renderColumn = this.renderColumn.bind(this);
  }

  transform(data) {
    return data.map((row) => {
      const { percentage } = row;
      const adjusted = percentage * arc;

      return [
        [row.name, adjusted, percentage],
        ['Gray', 100 * arc - adjusted, 100 - percentage],
        ['Rest', 100 - arc * 100, 0],
      ];
    });
  }

  graphOptionsForRevenue(rows) {
    return {
      options: {
        legend: 'none',
        pieSliceText: 'none',
        pieStartAngle: 240,
        pieSliceBorderColor: 'transparent',
        tooltip: { trigger: 'none' },
        titlePosition: 'none',
        axisTitlesPosition: 'none',
        enableInteractivity: false,
        chartArea: {
          width: '100%',
          height: '100%',
        },
        pieHole: 0.8,
        backgroundColor: 'transparent',
        slices: {
          0: { color: '#C86DD7' },
          1: { color: '#eceaea' },
          2: { color: 'transparent' },
        },
      },
      rows,
      columns: [
        {
          type: 'string',
          label: 'Name',
        },
        {
          type: 'number',
          label: 'RealPercentage',
        },
        {
          type: 'number',
          label: 'Percentage',
        },
      ],
    };
  }

  renderLoadingMessage() {
    return <div>Loading...</div>;
  }

  renderGraph(graphId, data) {
    const options = this.graphOptionsForRevenue(data);
    const props: any = {
      chartType: 'PieChart',
      loader: this.renderLoadingMessage(),
      rows: options.rows,
      columns: options.columns,
      options: options.options,
      graph_id: 'category-graph-' + graphId,
      width: '100%',
      height: '120px',
      legend_toggle: true,
    };

    return <Chart {...props} />;
  }

  renderColumn(row, key) {
    return (
      <Col xs={6} sm={4} key={key} className='text-center percentage-arcs-graph'>
        {this.renderGraph(key, row)}
        <span className='percentage-arcs-graph-percentage'>{row[0][2]}%</span>
        <p className='percentage-arcs-name'>{row[0][0]}</p>
      </Col>
    );
  }

  renderContent() {
    const data = this.transform(this.props.data);
    if (!data || !data.length) {
      return (
        <CardBody className='text-md-center'>
          <NoDataAvailable />
        </CardBody>
      );
    }

    return (
      <CardBody className='percentage-arcs'>
        <Row>{data.map(this.renderColumn)}</Row>
      </CardBody>
    );
  }

  render() {
    return (
      <Card className={classNames(this.props.className)}>
        <CardHeader>{this.props.title}</CardHeader>
        {this.renderContent()}
      </Card>
    );
  }
}
